import firebase from "firebase";
import instance from "../../services/axios";
import api from "../../services/Api";

export const handlegoogle = async () => {
  var retorno;
  const baseprovider = new firebase.auth.GoogleAuthProvider();
  await firebase
    .auth()
    .signInWithPopup(baseprovider)
    .then(async (result) => {
      const token = result.user._lat;
      //axios.defaults.baseURL = 'http://172.16.0.12/alertacelular/api/';
      instance.defaults.headers.Authorization = token;
      // console.log("result >>>", result)
      if (result.additionalUserInfo.isNewUser === true) {
        const cpf = undefined;
        const nomeCompleto = result.additionalUserInfo.profile.name;
        const genero = result.additionalUserInfo.profile.gender;
        const email = result.additionalUserInfo.profile.email;
        const foto = result.additionalUserInfo.profile.picture;
        const local = result.additionalUserInfo.profile.locale;
        const uid = result.user.uid;

        const NewUser = {
          nome: nomeCompleto,
          genero: genero,
          email: email,
          foto: foto,
          local: local,
          uid: uid,
          cpf: cpf,
          telefone: undefined,
        };

        await api.saveUser(NewUser)
        .then((Response) => {
          // console.log("response salv banco", Response)
          retorno = Response;
        })
        .catch((err) => {
          console.log("erro banco", err)
          retorno = err;
        });
      } else {
        retorno = result;
      }
    })
    .catch((err) => {
      console.log("erro firebase", err)
      retorno = err;
    });
  return retorno;
};



// WEBPACK FOOTER //
// ./src/assets/js/loginGoogle.js